const createBulkUpsertBatchDetails = require('../batch/upsert-batch-details')
const { fsShipmentDateParser } = require('../shipment/tools/safe-date-parser')

function createBatchHelpers ({ mainApi, logger }) {
  const bulkUpsertBatchDetails = createBulkUpsertBatchDetails({ mainApi, logger })

  async function fromRmsLines (lines = []) {
    const items = lines
      .filter(line => line && line.batchNumber && line.expiryDate)
      .map(line => ({
        skuCode: line.productId,
        batchNo: line.batchNumber,
        manufacturer: line.manufacturer,
        expiry: new Date(fsShipmentDateParser(line.expiryDate)).toJSON()
      }))
    await bulkUpsertBatchDetails(items)
  }

  return { fromRmsLines }
}

module.exports = createBatchHelpers
